export const KPI_CATEGORY_OPTIONS = [
  { value: "", label: "None" },
  { value: "Risks", label: "Risks" },
  { value: "Controls", label: "Controls" },
  { value: "Incidents", label: "Incidents" },
  { value: "Audits", label: "Audits" },
  { value: "Vendors", label: "Vendors" },
  { value: "Policies", label: "Policies" },
  { value: "Tasks", label: "Tasks" },
  { value: "Other", label: "Other" },
];

export const KPI_SUBCATEGORY_OPTIONS = {
  Risks: ["Operational", "Compliance", "Strategic", "Financial", "Cyber"],
  Controls: ["Coverage", "Testing", "Effectiveness", "Automation"],
  Incidents: ["Response Time", "Volume", "Severity", "SLA"],
  Audits: ["Findings", "Remediation", "Completion"],
  Vendors: ["Risk Reviews", "Due Diligence", "SLA", "Performance"],
  Policies: ["Acknowledgement", "Exceptions", "Training"],
  Tasks: ["Backlog", "Completion", "SLA"],
  Other: ["General"],
};

export const getKpiSubcategoryOptions = (category) => {
  if (!category) return [];
  const values = KPI_SUBCATEGORY_OPTIONS[category] || KPI_SUBCATEGORY_OPTIONS.Other || [];
  return values.map((value) => ({ value, label: value }));
};
